<template>
  <div class="mh-100 h-100 map-container">
    <b-spinner
      v-if="loadingMapData"
      label="Loading data"
      variant="info"
      class="map-spinner"
    />
    <MapSubTierHeaders v-if="tierHeadings" />
    <MapPopup
      v-if="selectedGeometry && showPopups"
      :title="selectedGeometryName"
      :popup-details="popupDetails"
    />
    <TheMap
      :show-bounds="showBounds"
      :any-zoom="anyZoom"
      :selected-geometry.sync="selectedGeometry"
      :selected-geometry-name.sync="selectedGeometryName"
    />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import MapSubTierHeaders from '@/components/public/MapSubTierHeaders/MapSubTierHeaders.vue'
import MapPopup from '@/components/public/Popup/MapPopup.vue'
import TheMap from '@/components/public/TheMap/TheMap.vue'

import { VisNode, MapPopupDetails } from '@/types'
import { MAP_POPUP_TOTAL_ITEMS_CONFIG_KEY } from '@/constants'

const components = {
  MapSubTierHeaders,
  MapPopup,
  TheMap,
}
const props = {
  showPopups: {
    type: Boolean,
    default: true,
  },
  showBounds: {
    type: Boolean,
    default: false,
  },
  anyZoom: Boolean,
  tierHeadings: {
    type: Boolean,
    default: true,
  },
}

@Component({ components })
export default class MapWrapper extends Vue.extend({ props }) {
  selectedGeometry: string | null = null
  selectedGeometryName = ''

  get loadingMapData () {
    return !this.$typedStore.public.geometries.loaded
  }

  get locationData () {
    return this.$typedStore.public.geometries.locationData
  }

  get locationCounts () {
    return this.$typedStore.public.geometries.locationCounts
  }

  get mapPopupTotalItems () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config[MAP_POPUP_TOTAL_ITEMS_CONFIG_KEY]
  }

  get popupDetails (): MapPopupDetails {
    const data = Object.entries(this.locationData[this.selectedGeometry || ''] || {})
      .reduce((acc, [key, value]) => (
        { ...acc, [key]: value.toString() }
      ), {})

    return {
      node: {
        totalString: this.totalString,
        data,
      } as VisNode,
      projectCount: this.locationCounts[this.selectedGeometry || ''],
    }
  }

  get totalString () {
    const totalsByColumn = this.locationData[this.selectedGeometry || '']
    const leafNodes = [{
      data: totalsByColumn,
    }]

    let sumTotalsByUnit = this.$typedStore.visualisationApp.sumTotalsByUnit({ leafNodes })
    if (this.mapPopupTotalItems && this.mapPopupTotalItems.length > 0) {
      sumTotalsByUnit = this.$typedStore.visualisationApp.sumFieldsByUnit({ leafNodes }, this.mapPopupTotalItems)
    }

    return this.$typedStore.visualisationApp.totalString({ sumTotalsByUnit })
  }
}
</script>

<style scoped>
.map-container {
  position: relative;
  /* 15px is the offset number in
  SideTab.vue of the active tab */
  margin-left: -15px;
  z-index: 0;
}

.map-spinner {
  height: 100px;
  width: 100px;
  position: absolute;
  top: calc(50% - 50px);
  left: calc(50% - 50px);
}
</style>
